import React from "react";
import PropTypes from "prop-types";
// Material imports
import makeStyles from "@mui/styles/makeStyles";
import ResponsiveImage from "../responsive-image/ResponsiveImage";
const useStyles = makeStyles(() => ({
  imageContent: {
    width: "100%",
    height: "100%",
    maxWidth: 625,
    maxHeight: 448
  }
}));
const MediaContent = ({
  content,
  noImageSrc = "",
  noImageUrl = false
}) => {
  const classes = useStyles();
  return /*#__PURE__*/React.createElement(React.Fragment, null, (content === null || content === void 0 ? void 0 : content.video) !== "" && Reflect.getOwnPropertyDescriptor(content, "video") ? /*#__PURE__*/React.createElement("iframe", {
    width: "90%",
    height: "350",
    frameBorder: "0",
    src: `${content === null || content === void 0 ? void 0 : content.video}?&autoplay=0&muted=0`
  }) : !noImageUrl && /*#__PURE__*/React.createElement(ResponsiveImage, {
    images: content.images,
    imageAlt: "steps",
    imageStyles: classes.imageContent,
    noImageSrc: noImageSrc
  }));
};
MediaContent.propTypes = {
  content: PropTypes.object.isRequired,
  noImageSrc: PropTypes.string,
  noImageUrl: PropTypes.bool
};
export default MediaContent;